import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DashboardLayout = _resolveComponent("DashboardLayout");
    return (_openBlock(), _createBlock(_component_DashboardLayout, {
        "page-title": "داشبورد",
        breadcrumbs: $setup.breadcrumbs
    }, null, 8, ["breadcrumbs"]));
}
